import { Link } from 'react-router-dom';
import { ArrowLeft, BellRing, Building2, Mail, Landmark } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { accountConfigurationItems } from '../lib/dashboardContent';
import { ExtensionPairing } from '../components/ExtensionPairing';
import { NotificationPreferences } from '../components/NotificationPreferences';

const icons = {
  'Compte bancaire': Landmark,
  Email: Mail,
  'Comptes officiels': Building2,
  'Preferences de rappels': BellRing,
};

export const ConfigurationPage = () => {
  const { isDark } = useTheme();

  return (
    <div className={`min-h-screen px-5 py-8 ${isDark ? 'bg-[#0F0F1A] text-white' : 'bg-[#FAFBFC] text-[#1d1d1f]'}`}>
      <div className="max-w-4xl mx-auto">
        <Link to="/dashboard" className={`inline-flex items-center gap-2 mb-8 text-sm ${isDark ? 'text-[#94A3B8]' : 'text-gray-600'}`}>
          <ArrowLeft size={17} />
          Retour au copilote
        </Link>

        <div className="mb-8">
          <p className="text-[#81d8d0] text-sm font-semibold mb-2">Configuration du compte</p>
          <h1 className="text-3xl md:text-5xl font-semibold tracking-tight mb-4">
            Toutes les connexions restent ici.
          </h1>
          <p className={`text-lg leading-8 max-w-2xl ${isDark ? 'text-[#94A3B8]' : 'text-gray-600'}`}>
            Le copilote utilise ces reglages en arriere-plan, sans transformer chaque connexion en nouveau menu.
          </p>
        </div>

        <NotificationPreferences />

        <ExtensionPairing />

        <div className="grid md:grid-cols-2 gap-4">
          {accountConfigurationItems.map((item) => {
            const Icon = icons[item.label];
            return (
              <section
                key={item.label}
                className={`rounded-2xl border p-5 ${isDark ? 'bg-white/5 border-white/10' : 'bg-white border-gray-200'}`}
              >
                <div className="w-11 h-11 rounded-xl bg-[#81d8d0]/15 flex items-center justify-center mb-5">
                  <Icon size={22} className="text-[#81d8d0]" />
                </div>
                <h2 className="text-xl font-semibold mb-2">{item.label}</h2>
                <p className={`text-sm leading-6 mb-4 ${isDark ? 'text-[#94A3B8]' : 'text-gray-600'}`}>
                  {item.detail}
                </p>
                <button
                  type="button"
                  disabled
                  className={`px-4 py-2 rounded-xl text-sm font-semibold cursor-not-allowed ${
                    isDark ? 'bg-white/10 text-[#94A3B8]' : 'bg-gray-100 text-gray-500'
                  }`}
                >
                  Bientôt disponible
                </button>
              </section>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ConfigurationPage;
